import { render, staticRenderFns } from "./CardQuickAccess.vue?vue&type=template&id=70d8e4a6&scoped=true"
import script from "./CardQuickAccess.vue?vue&type=script&lang=js"
export * from "./CardQuickAccess.vue?vue&type=script&lang=js"
import style0 from "./CardQuickAccess.vue?vue&type=style&index=0&id=70d8e4a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8e4a6",
  null
  
)

export default component.exports